import React from 'react';
import {
  Box,
  Typography,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSettings } from '../hooks/useSettings';
import PageContainer from '../components/common/PageContainer';
import SectionHeader from '../components/common/SectionHeader';

// Sub-components
import SettingsCategories from './settings/SettingsCategories';
import UserRolesSection from './settings/UserRolesSection';
import CitiesSection from './settings/CitiesSection';
import CityDuplicatesSection from './settings/CityDuplicatesSection';
import RoutesSection from './settings/RoutesSection';
import CityClientsSection from './settings/CityClientsSection';

const Settings = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const {
    categories,
    settings,
    loading,
    error,
    success,
    setError,
    setSuccess,
    fetchSettings,
    updateSetting,
    userStats,
    fetchUserStats,
    allPermissions,
    fetchPermissions,
    createRole,
  } = useSettings();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const breadcrumbs = [
    { label: 'Inicio', path: '/' },
    { label: 'Configuración', path: '/settings' },
  ];

  const actions = [
    {
      label: 'Actualizar',
      variant: 'outlined',
      onClick: fetchSettings,
    },
  ];

  return (
    <PageContainer loading={loading} onLogout={handleLogout}>
      <SectionHeader
        title="Configuración del Sistema"
        subtitle="Administre las variables de configuración y roles."
        breadcrumbs={breadcrumbs}
        actions={actions}
      />

      {/* Alerts */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess('')}>
          {success}
        </Alert>
      )}

      {/* General Settings Accordions */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#0e141b' }}>
          Configuraciones Generales
        </Typography>
        <SettingsCategories
          categories={categories}
          settings={settings}
          onSettingChange={updateSetting}
        />
      </Box>

      {/* User Stats & Roles */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#0e141b' }}>
          Seguridad y Acceso
        </Typography>
        <UserRolesSection
          stats={userStats}
          permissions={allPermissions}
          onFetchStats={fetchUserStats}
          onFetchPermissions={fetchPermissions}
          onCreateRole={createRole}
        />
      </Box>



      {/* Logística y Ciudades */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700, color: '#0e141b' }}>
          Logística
        </Typography>
        <CitiesSection />
        <CityDuplicatesSection />
        <RoutesSection />
        <CityClientsSection />
      </Box>
    </PageContainer>
  );
};

export default Settings;
